import React from "react";

const Header =()=> {
  return (
    
  <div className="header-container">
  <div>
    <h1>Travel Made Simple </h1>
    <h2>– Visa, Flights & Holidays<br/>
in One Place</h2>
    <button>Get a Visa Quote</button>
  </div>
  </div>
    
  );
}

export default Header;
